import { isEmpty } from '@tmhcc/util';

export class PolicyMasterData {
  TransactionTypes: TransactionTypes[] = [];
  TransactionStatuses: TransactionStatuses[] = [];
}

export class TransactionTypes {
  id: string;
  description: string;

  constructor(id: string, description: string) {
    if (isEmpty(id) || isEmpty(description)) {
      throw new Error('invalid Transaction Types');
    }

    this.id = id;
    this.description = description;
  }
}

export class TransactionStatuses {
  id: string;
  description: string;

  constructor(id: string, description: string) {
    if (isEmpty(id) || isEmpty(description)) {
      throw new Error('invalid Transaction Status');
    }

    this.id = id;
    this.description = description;
  }
}
